import styled from "@emotion/styled";

import { responsiveStyles } from "scmp-app/components/header/features/styles";
import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";
import { DynamicSubscriptionButton } from "scmp-app/lib/sdk/dynamics";

export const Container = styled.div<ResponsiveStyledProps>`
  ${responsiveStyles}
`;

export const StyledDynamicSubscriptionButton = styled(DynamicSubscriptionButton)``;
